import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";

const useRatesLogic = () => {
  const apiRoute = "vehiclerates";
  const onlyForm = undefined;

  const initFields = [
    {
      name: "season",
      label: "Season",
      type: "dropdown",
      disableEditForNonAdmin: true,
      isRequired: true,
      err: "Season is required",
      returnID: true,
    },
    {
      name: "vehicle_class",
      label: "Vehicle Category",
      type: "dropdown",
      disableEditForNonAdmin: true,
      isRequired: true,
      err: "Vehicle Category is required",
      returnID: true,
    },
    {
      name: "currency",
      label: "Currency",
      type: "dropdown",
      isRequired: false,
      err: "Currency is required",
      disabled: true,
      returnID: true,
      placeholder: "Season's branch currency",
    },
    {
      name: "daily_rate",
      label: "Daily rate",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Daily rate is required",
    },
    {
      name: "weekly_rate",
      label: "Weekly rate",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Weekly rate is required",
    },
    {
      name: "monthly_rate",
      label: "Monthly rate",
      type: "number",
      minValue: 0,
      isRequired: true,
      err: "Monthly rate is required",
    },
    // Add more fields as needed
  ];

  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin];
  const deleteRoles = [admin];
  const editRoles = [admin, financeRole, managerRole];

  const getPromises = (temp) => {
    return [
      fetchDataAndMapToField(config, "vehicleclasses", "vehicle_class", temp),
      fetchDataAndMapToField(config, "seasons", "season", temp, "Name"),
      fetchDataAndMapToField(
        config,
        "currencies",
        "currency",
        temp,
        "code",
        "symbol"
      ),
    ];
  };

  return {
    apiRoute,
    onlyForm,
    initFields,
    addRoles,
    deleteRoles,
    editRoles,
    getPromises,
  };
};

export default useRatesLogic;
